import { Routes } from '@angular/router';
import { roleGuard } from '../../../lib/guards/admin-role.guard';
import { SYSTEM_LOG_CONFIG } from './base/system-log-config';

export const systemLogRoutes: Routes = [
  {
    path: SYSTEM_LOG_CONFIG.routePath,
    canActivate: [roleGuard('ADMIN_SYSTEM')],
    data: {
      title: '시스템 로그',
    },
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/system-log-list-page/system-log-list-page.component'
          ).then((m) => m.SystemLogListPageComponent),
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/system-log-detail-page/system-log-detail-page.component'
              ).then((m) => m.SystemLogDetailPageComponent),
            data: {
              title: '시스템 로그 상세',
            },
          },
        ],
      },
    ],
  },
];
